// extracted by mini-css-extract-plugin
module.exports = {"brand-title":"ufb-logo_brand-title__2j63q","logo":"ufb-logo_logo__DsQUc"};